













































import {
  Vue,
  Component
} from "@/shared/vuepack";
import AccountAlertBellCobrand from "@/shared/components/accountAlert/AccountAlertBellCobrand.vue";
import AdvisorAlert from "@/shared/components/accountAlert/AdvisorAlert.vue";
import Logo from "@/shared/components/Logo.vue";
import { ToHome } from "@/shared/route-names";
import { HsabAccountSelection, AccountsSummary } from "@/employee/route-names";
import { useUserStore } from "@/shared/store/user";
import { useNavigationStore } from "@/shared/store/navigation";
import { useImpersonatorStore } from "@/shared/store/impersonator";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    AdvisorAlert,
    AccountAlertBellCobrand,
    Logo
  }
})
export default class Header extends Vue {
  userStore = useUserStore();
  navigationStore = useNavigationStore();
  impersonatorStore = useImpersonatorStore();
  custodianSettingsStore = useCustodianSettingsStore();
  hsabAccountsStore = useHsabAccountsStore();
  featureFlagStore = useFeatureFlagStore();

  created () {
    this.hsabAccountsStore.getHsabAccountDisplayType();
    this.hsabAccountsStore.getUserHasNotionalAccounts();
  }

  ToHome = ToHome;

  navOpen = false;

  toggleNav () {
    this.navigationStore.toggleMobileMenu();
  }

  get displayName () {
    if (!this.userStore.currentUser.displayName.trim()) {
      return "New User";
    }

    return this.userStore.currentUser.displayName;
  }

  get impersonatedUserFullName () {
    return this.impersonatorStore.impersonatedName;
  }

  get hsabAccountSelection () {
    return HsabAccountSelection;
  }

  get isLoadingUserHasNotionalAccounts () {
    return !this.hsabAccountsStore.isAccountDisplayTypeLoaded;
  }

  get showNotifications () {
    return !this.custodianSettingsStore.isHsaBankCustodian || this.featureFlagStore.flags.hsa6356EnableHsabAdvisorAlerts;
  }

  get homeNavigation () {
    if (this.hsabAccountsStore.userHasAnyNotionalAccounts) {
      return { name: AccountsSummary };
    }

    return ToHome;
  }
}
